export default "__VITE_ASSET__Dl9w9dqj__"